///<reference path="../common/smart-mover.models.ts"/>
///<reference path="../common/data-template-base.ts"/>
///<reference path="../common/collection-base.ts"/>


module Meevo.Components.Controls.SmartMover {

    import Dictionary = _.Dictionary;

    export class PurchaseOrderSupplyCategoriesDataTemplate extends DataTemplateBase implements IDataTemplate {

        protected supplyCategories: SmartMoverCollectionBase<any>;

        public title: string;
        public allSelectedLabel: string;

        get collection() {
            return this.supplyCategories;
        }

        get totalSelectedCount(): number {
            return this.supplyCategories.value.length;
        }

        constructor(model: Dictionary<any>, properties: string[], { criteria }, items: IListElement[] = []) {
            super(model, properties, criteria);

            this.supplyCategories = new SmartMoverCollectionBase(this.model[properties[0]], items, { criteria });

            this.title = 'LABEL_SUPPLY_CATEGORIES';
            this.allSelectedLabel = 'LABEL_ALL_SUPPLY_CATEGORIES';
            this.totalSelectedMessage = 'LABEL_TOTAL_SUPPLY_CATEGORIES_SELECTED';
        }

    }
}